export function getEnvironmentType() {
  const { hostname } = window.location;

  if (hostname.includes('localhost')) {
    return 'local';
  }
  if (hostname.includes('admin.ppsidev.net')) {
    return 'dev';
  }
  if (hostname.includes('admin-test.ppsidev.net')) {
    return 'test';
  }
  if (hostname.includes('admin-preprod.ppsidev.net')) {
    return 'ppe';
  }
  return 'prod';
}

export function getEnvironmentTranslationId() {
  const environmentType = getEnvironmentType();

  switch (environmentType) {
    case 'local': {
      return 'app.namelocal';
    }
    case 'dev': {
      return 'app.namedev';
    }
    case 'test': {
      return 'app.nametest';
    }
    case 'ppe': {
      return 'app.nameppe';
    }
    default:
    case 'prod': {
      return 'app.name';
    }
  }
}
